import React, { memo } from 'react';
import { AnimatePresence } from 'framer-motion';
import { AccordionPanelVariant, StyledAccordionPanel } from './AccordionPanel.styles';

interface AccordionPanelProps {
  id: string;
  buttonId: string;
  isActive: boolean;
  className?: string;
  variant?: AccordionPanelVariant;
}

export const AccordionPanel: React.FC<AccordionPanelProps> = memo(
  ({ isActive, id, buttonId, children, className, variant = 'default' }) => {
    return (
      <AnimatePresence initial={false}>
        {isActive && (
          <StyledAccordionPanel
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.2, ease: 'easeInOut' }}
            id={id}
            variant={variant}
            role="region"
            aria-labelledby={buttonId}
            aria-hidden={!isActive}
            className={className}
          >
            {children}
          </StyledAccordionPanel>
        )}
      </AnimatePresence>
    );
  },
);
